import { createContext, useContext } from 'react'

export const UserContext = createContext({
  isAuthenticated: false,
  sites: [],
  language: 'en_US'
})

export const useUserContext = () => useContext(UserContext)
